import iotDeviceConfig, {FEATURE_TYPES} from '../../../../services/iotDevice/iotDeviceConfig';
import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useAemPauseModeEnabled = (iotDevice) => {
    const isEnabledGlobally = iotDeviceGlobalConfigService.isGlobalAemPauseMode(iotDevice);
    const isFeatureEnabled = iotDeviceFeatureConfigService.isAemPauseModeEnabled();
    const isFwuCanHelp = !iotDeviceConfig.isFeatureUpperBound(FEATURE_TYPES.AEM_PAUSE_MODE);
    const isEnabled = iotDeviceSettingsService.isSettingAvailable(
        iotDevice,
        isEnabledGlobally,
        isFeatureEnabled,
        true,
        isFwuCanHelp
    );

    return isEnabled;
};

export default useAemPauseModeEnabled;
